export default __webpack_public_path__ + "resources/icons/n111-2575.png";